import { isNil, isEmpty } from 'lodash';
import { API, EmptyData } from './api/req.js';

const actions = {
  /**state.content=null
   *
   * CV Wizars steps content
   */
  async loadCVWContent({ commit, dispatch }) {
    try {
      let res = await this.$axios.get(API['data']);
      commit('INIT_CVW_CONTENT', res.data);

      const payload = { stepname: 'firststepLoggedIn', data: null };
      await dispatch('updateStepperStatus', payload);

      commit('SET_INIT_CVW');
    } catch (err) {
      let error = new Error(err);
      commit('SET_ERROR', error);
    }
  },

  setStep({ commit }, stepNumber) {
    commit('SET_CURRENT_STEP', stepNumber);
  },

  /**
   *
   * Get stepper status on every step entry
   * @param {Object} payload - holds stepname and data to server
   * @returns StepperStatus
   */
  async updateStepperStatus({ commit }, payload) {
    if (payload.stepname) {
      if (!payload.data) {
        payload.data = EmptyData[payload.stepname];
      }

      return this.$axios
        .post(API[payload.stepname], payload.data)
        .then(res => {
          commit('SET_STEPPER_STATUS', res.data);
          if (payload.stepname == 'firststepLoggedIn') {

            commit(
              'SET_USER_CVS_NUMBER',
              res.data.Wizard.Seeker?.Profile.ValidCVs || 0
            );
          }

          /**
           * @see isEmpty
           * @param {String} RegistrationDate -  set true if the user is register to smart alerts
           */
          commit(
            'SET_USER_REGISTER_SMART_ALERTS',
            !isEmpty(res.data.Wizard.Seeker?.SmartAgents)
          );

          return res.data;
        })
        .catch(err => {
          console.log('stepper error', err);
        });
    }
  }
};

export default actions;
